import React, {useContext} from "react";
import GenericDialog from '@common/GenericDialog';
import {ContentContext} from "@context/ContentContext";
import MediaPlayer from "./MediaPlayer";
import {BrandContext} from "@context/BrandContext";

const MediaPlayerDialog = props => {
    const {open = false} = props;
    const brandConfig = useContext(BrandContext);
    const {dialogMediaObject, setDialogMediaObject} = useContext(ContentContext);
    const DIALOG_WIDTH_OBJ = {
        WIDGET: 700,
        VIDEO: 900,
        SCORCHER: 970,
        DESMOS: 900,
        DESMOS_GRAPHING: 900,
        DESMOS_GEOMETRY: 1000,
        DESMOS_SCIENTIFIC: 800,
        DESMOS_MATRIX: 800,
    }
    const MEDIA_TYPE = {
        VIDEO: {name: brandConfig.videoName},
        WIDGET: {name: brandConfig.widgetName},
        DESMOS: {name: brandConfig.desmosName},
        SCORCHER: {name: brandConfig.scorcherName},
    }
    const widgetBrandWidthOffset = (brandConfig.brandCode == 'SENIORMATHS' && dialogMediaObject?.mediaType == 'WIDGET') ? 220 : 0;

    const handleClose = () => {
        setDialogMediaObject(null);
        if (typeof dialogMediaObject?.callback === 'function') dialogMediaObject?.callback();
    }

    return (
        <GenericDialog
            open={open}
            title={dialogMediaObject?.mediaName ? dialogMediaObject.mediaName : MEDIA_TYPE[dialogMediaObject?.mediaType]?.name}
            buttons={[{name: 'Close'}]}
            onClose={handleClose}
            dialogWidth={DIALOG_WIDTH_OBJ[(dialogMediaObject?.mediaType === 'DESMOS' && dialogMediaObject?.mediaSubType) ? dialogMediaObject?.mediaSubType : dialogMediaObject?.mediaType] + widgetBrandWidthOffset}
            fullscreen={dialogMediaObject?.fullscreen}
            allowFullScreen={dialogMediaObject?.mediaType !== 'VIDEO'}
        >
            <MediaPlayer mediaId={dialogMediaObject?.mediaId} mediaType={dialogMediaObject?.mediaType} conceptId={dialogMediaObject?.conceptId} />
        </GenericDialog>
    )
}

export default MediaPlayerDialog;